import { makeStyles } from '@mui/styles'

import { sharedGenericStyling } from './shared'
import { SPACING } from '@fedsim/constants'

export const useCardStyles = makeStyles(theme => {
  return {
    ...sharedGenericStyling,
    list: {
      ...sharedGenericStyling.list,
      overflow: 'unset',
      padding: 0,
      margin: 0,
      display: 'flex',
      flexWrap: 'wrap',
      justifyContent: 'start',
      alignItems: 'center'
    },
    card: {
      // boxShadow: 12,
      backgroundColor: 'black',
      color: 'white',
      // structure
      alignSelf: 'stretch',
      display: 'flex',
      flex: 1,
      flexDirection: 'column',
      justifyContent: 'space-between',
      // box
      margin: '0 8px 12px',
      padding: '.5rem',
      // width
      minHeight: 240, 
      minWidth: 200,
      maxWidth: 350,
      '&:hover': {
          transform: 'scale(1.01)'
      }
    },
    actions: {
      // display: 'flex',
      // justifyContent: 'space-between',
      // alignItems: 'center',
      marginBottom: theme.spacing(SPACING),
    },
    selected: {
      margin: theme.spacing(0.6, 0)
    }
  }
})
